const backups = {
  title: 'Copias de seguridad',
  menu: 'Copias de seguridad',
  forbidden: 'No tiene permisos para acceder a las copias de seguridad.',
  backupTitle: 'Crear copia de seguridad',
  backupHint:
    'Descarga una copia cifrada de toda la base de datos. Guarde bien la frase de cifrado: sin ella la copia no se puede restaurar.',
  passphrase: 'Frase de cifrado',
  passphraseConfirm: 'Confirme la frase de cifrado',
  passphraseHint: 'Al menos %{min} caracteres.',
  download: 'Descargar copia',
  backupStarted: 'Se ha iniciado la descarga de la copia.',
  backupFailed: 'No se pudo crear la copia de seguridad.',
  restoreTitle: 'Restaurar copia',
  restoreWarning:
    'La restauración reemplaza toda la base de datos por el contenido de la copia. La aplicación no está disponible mientras se restaura. Antes se realiza una copia de seguridad de los datos actuales.',
  restore: 'Restaurar',
  restoreOk: 'Base de datos restaurada correctamente.',
  restoreFailed: 'No se pudo restaurar la copia.',
  confirmTitle: '¿Restaurar esta copia?',
  confirmBody:
    'Esto sobrescribe todos los datos actuales con la copia subida. No se puede deshacer desde la interfaz.',
};

export default backups;
